import {FC, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useNavigate} from 'react-router-dom'
import {useAuth} from '../auth'
import {hidesPayments} from '../install-app/core/androidApp'
import {BUYER_LINKS_INTRO_EVENT, buyerLinksSettingsPath, shouldAnnounceBuyerLinks} from './buyerLinksIntro'
import '../apps/invoice-management/invoice-print/intro/printPageIntro.scss'

type Feature = {icon: string; title: string; text: string}

const FEATURES: Feature[] = [
  {
    icon: 'la-share-alt',
    title: 'لینک صورتحساب برای خریدار',
    text: 'از منوی هر صورتحساب یا پیش‌فاکتور، «اشتراک‌گذاری با خریدار»: لینک را با پیامک بفرستید یا کپی کنید. خریدار بدون ورود به پنل آن را می‌بیند.',
  },
  {
    icon: 'la-check-double',
    title: 'پاسخ خریدار',
    text: 'خریدار صورتحساب را تأیید یا با ذکر علت رد می‌کند، نظر می‌نویسد، آنلاین می‌پردازد یا رسید پرداختش را ثبت می‌کند؛ هر پاسخ به شما اعلان می‌شود.',
  },
  {
    icon: 'la-link',
    title: 'دکمهٔ لینک در هر ردیف',
    text: 'کنار هر صورتحساب در فهرست: ✓✓ یعنی خریدار لینک را باز کرده، ✓ سبز تأیید و ✗ قرمز رد؛ عدد زرد رسیدهایی است که منتظر بررسی شماست.',
  },
  {
    icon: 'la-robot',
    title: 'ارسال خودکار پیامک',
    text: 'هنگام ثبت صورتحساب یا پس از ثبت موفق در سامانهٔ مودیان؛ برای همهٔ خریداران یا خریداران خاص. می‌توانید تأیید خریدار را هم به ارسال خودکار صورتحساب به سامانه وصل کنید.',
  },
]

/**
 * The introduction of buyer links, opened only from its item in «امکانات تازه». «تنظیم لینک خریداران» opens the
 * selected business's «لینک خریداران» settings.
 */
export const BuyerLinksIntroGate: FC = () => {
  const {currentUser} = useAuth()
  const navigate = useNavigate()
  const [show, setShow] = useState(false)

  useEffect(() => {
    const open = () => setShow(true)
    window.addEventListener(BUYER_LINKS_INTRO_EVENT, open)
    return () => window.removeEventListener(BUYER_LINKS_INTRO_EVENT, open)
  }, [])

  if (!show || !shouldAnnounceBuyerLinks(currentUser)) return null

  const close = () => setShow(false)
  const settings = () => {
    setShow(false)
    navigate(buyerLinksSettingsPath(Number(currentUser?.cpi || 0)))
  }

  return (
    <Modal show onHide={close} centered size='lg' fullscreen='sm-down' scrollable dialogClassName='ppi-modal' aria-labelledby='buyer-links-intro-title'>
      <Modal.Body className='ppi-modal__body'>
        <button type='button' className='ppi-modal__close' onClick={close} aria-label='بستن'>
          <i className='las la-times' aria-hidden='true' />
        </button>

        <div className='ppi-content'>
          <span className='ppi-eyebrow'>
            <i className='las la-star' aria-hidden='true' />
            تازه
          </span>
          <h2 id='buyer-links-intro-title' className='ppi-title'>
            لینک خریدار
          </h2>
          <p className='ppi-lead'>
            صورتحساب و پیش‌فاکتور را با یک لینک برای خریدار بفرستید و پاسخ او را همان‌جا ببینید: باز کردن، تأیید یا رد،
            نظر، پرداخت آنلاین و رسید پرداخت. همهٔ لینک‌ها، دستی یا خودکار، با امکان غیرفعال و فعال کردن در سابقه می‌مانند.
          </p>

          <ul className='ppi-features' aria-label='امکانات لینک خریدار'>
            {FEATURES.map((feature) => (
              <li key={feature.title} className='ppi-feature'>
                <span className='ppi-feature__icon' aria-hidden='true'>
                  <i className={`las ${feature.icon}`} />
                </span>
                <span>
                  <strong>{feature.title}</strong>
                  <span className='ppi-feature__text'>{feature.text}</span>
                </span>
              </li>
            ))}
          </ul>

          {/* No fee is spoken of in the Bazaar and Myket builds of the Android app. */}
          <section className='ppi-section' aria-labelledby='buyer-links-intro-more' hidden={hidesPayments()}>
            <h3 id='buyer-links-intro-more' className='ppi-section__title'>
              هزینه و پیگیری
            </h3>
            <p className='ppi-note'>
              هزینهٔ هر پیامک از کیف پول کسب‌وکار کم می‌شود؛ موجودی را کنار آیکون «امکانات تازه» می‌بینید و از «تنظیمات
              کسب‌وکار ← کیف پول» شارژ می‌کنید. در فهرست صورتحساب‌ها، فیلتر «پاسخ خریدار به لینک» صورتحساب‌های تأییدشده،
              ردشده یا منتظر پاسخ را جدا می‌کند؛ این پاسخ جدا از واکنش خریدار در کارپوشهٔ سامانهٔ مودیان است.
            </p>
          </section>
        </div>
      </Modal.Body>
      <Modal.Footer className='ppi-modal__footer'>
        <button type='button' className='btn btn-light' onClick={close}>
          بستن
        </button>
        <button type='button' className='btn btn-primary' onClick={settings}>
          <i className='las la-cog' aria-hidden='true' />
          تنظیم لینک خریداران
        </button>
      </Modal.Footer>
    </Modal>
  )
}
